/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpcomingClassRow } from './UpcomingClassRow';
import {
    UpcomingClassRowFromJSON,
    UpcomingClassRowFromJSONTyped,
    UpcomingClassRowToJSON,
    UpcomingClassRowToJSONTyped,
} from './UpcomingClassRow';

/**
 * 
 * @export
 * @interface WidgetDataUpcomingClassesWidgetData
 */
export interface WidgetDataUpcomingClassesWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataUpcomingClassesWidgetData
     */
    $type?: WidgetDataUpcomingClassesWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<UpcomingClassRow>}
     * @memberof WidgetDataUpcomingClassesWidgetData
     */
    items: Array<UpcomingClassRow>;
}


/**
 * @export
 */
export const WidgetDataUpcomingClassesWidgetDataTypeEnum = {
    UpcomingClasses: 'upcoming-classes'
} as const;
export type WidgetDataUpcomingClassesWidgetDataTypeEnum = typeof WidgetDataUpcomingClassesWidgetDataTypeEnum[keyof typeof WidgetDataUpcomingClassesWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataUpcomingClassesWidgetData interface.
 */
export function instanceOfWidgetDataUpcomingClassesWidgetData(value: object): value is WidgetDataUpcomingClassesWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataUpcomingClassesWidgetDataFromJSON(json: any): WidgetDataUpcomingClassesWidgetData {
    return WidgetDataUpcomingClassesWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataUpcomingClassesWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataUpcomingClassesWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(UpcomingClassRowFromJSON)),
    };
}

export function WidgetDataUpcomingClassesWidgetDataToJSON(json: any): WidgetDataUpcomingClassesWidgetData {
    return WidgetDataUpcomingClassesWidgetDataToJSONTyped(json, false);
}

export function WidgetDataUpcomingClassesWidgetDataToJSONTyped(value?: WidgetDataUpcomingClassesWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(UpcomingClassRowToJSON)),
    };
}

